import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: any, limit = 20, trail = '...'): string {
    if (value === null || value === undefined) {
      return '';
    }

    const text = String(value); // force to string

    return text.length > limit ? text.substring(0, limit) + trail : text;
  }

}
